<template>
<div>
    <el-dialog
        :title="$t('lang.PersonalInformation')"
        :visible="visible"
        :width="width"
        @close="close"
        :destroy-on-close="true" 
        :close-on-click-modal="false"
    >
        <div class="form-container">
            <el-form label-position="top" ref="form" :model="form" >
                <el-form-item :label="$t('lang.LegalName')" >
                    <el-input :placeholder="$t('lang.PleaseLegalName')" v-model="form.uname" />
                </el-form-item>
                <el-form-item :label="$t('lang.DateOfBirth')" >
                    <el-date-picker type="date" v-model="form.birthday" :placeholder="$t('lang.PleaseDateOfBirth')" style="width:100%;" />
                </el-form-item>
                <el-form-item :label="$t('lang.ideAddress')" >
                    <el-input v-model="form.address" :placeholder="$t('lang.PleaseIdeAddress')"  />
                </el-form-item>
                <el-form-item :label="$t('lang.IdentificationNumber')" >
                    <el-input v-model="form.idNo" :placeholder="$t('lang.PleaseIdentificationNumber')" />
                </el-form-item>
                
                <el-form-item :label="$t('lang.IdentificationDocuments')" >
                    <div class="photo">
                        <div class="up">
                            <el-upload class="uploader"  :http-request="uploadFrontImg"   :show-file-list="false"   :on-change="handleFrontImg" action="#">
                               <img v-if="frontImg" :src="frontImg" class="avatar">
                               <i v-else  class="el-icon-plus uploader-icon"></i>
                            </el-upload>
                            <div class="text">{{ $t("lang.frontIDCard") }}</div>
                        </div>
                        <div class="up">
                            <el-upload class="uploader" :http-request="uploadBackImg"   :show-file-list="false"   :on-change="handleBackImg" action="#">
                                <img v-if="backImg" :src="backImg" class="avatar">
                               <i v-else class="el-icon-plus uploader-icon"></i>
                            </el-upload>
                            <div class="text">{{ $t("lang.ReverseIDCard") }}</div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">{{ $t("lang.cancel") }}</el-button>
            <el-button type="primary" @click="submit">{{ $t("lang.Confirm") }}</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet, axiosPost} from '@/api/api';
export default {
    name:'verifyDialog',
    data(){
        return {
            title:'Verify',
            visible:false,
            width:'560px',
            form:{
                uname:'',
                birthday:'',
                address:'',
                idNo:'',
                idType:1,
                backImg:'',
                frontImg:'',
                id:''
            },
            url:{
                detail:BASE_GLOB_API+'/realName/detail',
                idCardPhoto:BASE_GLOB_API+'/realName/idCardPhoto',
                uploadIdCardImg:BASE_GLOB_API+'/realName/uploadIdCardImg',
            },
            api:BASE_GLOB_API,
            fileRaw:null,
            backImg:'',
            frontImg:'',
            rules:{
              
            },
        }
    },
    methods:{
        submit(){
            if(!this.form.uname){
                this.$message.error(this.$t("lang.PleaseLegalName"));
                return;
            }
            if(!this.form.birthday){
                this.$message.error(this.$t("lang.PleaseDateOfBirth"));
                return;
            }
            if(!this.form.address){
                this.$message.error(this.$t("lang.PleaseIdeAddress"));
                return;
            }
            if(!this.form.idNo){
                this.$message.error(this.$t("lang.PleaseIdentificationNumber"));
                return;
            }
            if(!this.form.frontImg){
                this.$message.error(this.$t("lang.frontIDCardText"));
                return;
            }
            if(!this.form.backImg){
                this.$message.error(this.$t("lang.ReverseIDCardText"));
                return;
            }
            axiosPost(this.url.idCardPhoto, this.form).then(res=>{
                if(res.code == 200){
                  this.close()
                  this.$emit('reset')
                  this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
              
            })
        },
        handleFrontImg(file, fileLists){
            console.log("handleFrontImg:", file, fileLists)
            this.fileRaw = file.raw;
        },
     
        uploadFrontImg(r){
            console.log("uploadFrontImg", r)
            let formData = new FormData();
            formData.append("file", this.fileRaw);
            axiosPost(this.url.uploadIdCardImg, formData).then(res=>{
                if(res.code == 200){
                    this.frontImg = this.api + res.result
                    this.form.frontImg = res.result
                }else{
                    this.$message.error(res.message);
                }
              
            })
        },
        handleBackImg(file, fileLists){
            console.log("handleBackImg:", file, fileLists)
            this.fileRaw = file.raw;
        },
     
        uploadBackImg(r){
            console.log("uploadBackImg", r)
            let formData = new FormData();
            formData.append("file", this.fileRaw);
            axiosPost(this.url.uploadIdCardImg, formData).then(res=>{
                if(res.code == 200){
                    this.backImg = this.api + res.result
                    this.form.backImg = res.result
                }else{
                    this.$message.error(res.message);
                }
              
            })
        },
        close(){
            this.visible = false;
            this.form.uname ='';
            this.form.birthday ='';
            this.form.address ='';
            this.form.idNo ='';
            this.form.backImg ='';
            this.form.frontImg ='';
            this.form.id ='';
        },
        open(option){
            console.log("open", option)
               
            if(option.auditState ==2){
                this.form.uname =option.uname
                this.form.birthday = option.birthday
                this.form.address =option.address
                this.form.idNo = option.idNo
                this.form.backImg =  option.backImg
                this.form.frontImg = option.frontImg
                this.backImg = this.api + option.backImg
                this.frontImg = this.api + option.frontImg
                this.form.id = option.id
            }else{
                this.form.id ='';
            }
            this.visible = true;
        }
    }
}
</script>
<style lang="less" scoped>
.form-container {
    ::v-deep .el-form {
        .el-form-item {
            .el-form-item__label {
                font-size:14px; line-height:1.46;
            }
        }
    }
    .photo{
        display: flex;
        .up{
            padding: 0 20px;
            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }
            .uploader{
                text-align: center;
            }
        }
        .text{
            text-align: center;
        }
    }
}
.uploader {
    ::v-deep .el-upload {
        border: 1px dashed #d9d9d9; border-radius:6px; cursor: pointer; position:relative;
        &:hover {
            border-color:#4458FE;
        }
        .uploader-icon {
            width:81px; height:81px; line-height:81px; font-size:28px; text-align:center;
        }
    }
}
</style>